import { Box, Tooltip, Typography } from '@mui/material'
import { USER_BY_ID } from './Tododata.ts'
import UserAvatar from './Useravtar.tsx'

interface Props {
  ids: string[] // task.assigneeIds, main assignee first
  size?: number
  max?: number // avatars shown before collapsing into "+N"
}

/** Overlapping avatars for everyone on a task. Hover shows all names. */
export default function AssigneeStack({ ids, size = 26, max = 2 }: Props) {
  const users = ids.map((id) => USER_BY_ID[id]).filter(Boolean)
  if (users.length === 0) return 

  const shown = users.slice(0, max)
  const extra = users.length - shown.length
  const overlap = `-${Math.round(size * 0.3)}px`
  const ring = { display: 'inline-flex', borderRadius: '50%', boxShadow: '0 0 0 2px #fff', position: 'relative' } as const

  return (
    <Tooltip
      arrow
      title={
        <Box>
          {users.map((u) => (
            <div key={u.id}>{u.name}</div>
          ))}
        </Box>
      }
    >
      <Box aria-label={`Assigned to ${users.map((u) => u.name).join(', ')}`} sx={{ display: 'inline-flex', alignItems: 'center' }}>
        {shown.map((u, i) => (
          <Box key={u.id} sx={{ ...ring, ml: i ? overlap : 0, zIndex: shown.length - i }}>
            <UserAvatar user={u} size={size} />
          </Box>
        ))}
        {extra > 0 && (
          <Box
            sx={{
              ...ring,
              ml: overlap,
              zIndex: 0,
              width: size,
              height: size,
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: '#E2DFCC',
              color: '#55513A',
              fontSize: Math.round(size * 0.42),
              fontWeight: 700,
            }}
          >
            +{extra}
          </Box>
        )}
      </Box>
    </Tooltip>
  )
}